/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as privilegeV1 from "./keyapis_subscription_privilege_v1.pb"

/**
 * Сервис реализует функционал управления технологическими планами(ТП).
 * ТП это подготовленный набор доступных услуг
 */

/**
 * Сервис технологических планов(ТП)
 */
export class PlanServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения технологического плана.
   * Метод доступен для: admin, mrf, master, ltp_first, service, application(subscription:read или subscription:edit)
   */
  GetPlan = (req: GetPlanRequestDto, init?: RequestInit): Promise<GetPlanResponseDto> => {
    return fm.request<GetPlanRequestDto, GetPlanResponseDto>(`${this.host}/subscription/api/v1/plan/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка технологических планов.
   * Метод доступен для: admin, service, mrf, master, ltp_first, service, application(subscription:read или subscription:edit)
   */
  GetPlanList = (req: GetPlanListRequestDto, init?: RequestInit): Promise<GetPlanListResponseDto[]> => {
    return fm.list<GetPlanListRequestDto, GetPlanListResponseDto>(`${this.host}/subscription/api/v1/plan/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества технологических планов.
   * Метод доступен для: admin, service, mrf, master, ltp_first, service, application(subscription:read или subscription:edit)
   */
  GetPlanCount = (req?: GetPlanCountRequestDto, init?: RequestInit): Promise<GetPlanCountResponseDto> => {
    return fm.request<GetPlanCountRequestDto, GetPlanCountResponseDto>(`${this.host}/subscription/api/v1/plan/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов иконок
 */
export enum PlanIconType {
  /**
   * Значение не указано
   */
  ICON_TYPE_UNKNOWN = "ICON_TYPE_UNKNOWN",
  /**
   * Быстро
   */
  FAST = "FAST",
  /**
   * Распознавание лиц
   */
  FACE_REC = "FACE_REC",
  /**
   * Безопасно
   */
  SAFE = "SAFE",
}
/**
 * Справочник типов иконок
 */
export type PlanIconTypeResponseEnum = keyof typeof PlanIconType
/**
 * Справочник типов иконок
 */
export type PlanIconTypeRequestEnum = Exclude<PlanIconTypeResponseEnum, "ICON_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum PlanPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type PlanPagingDirectionTypeResponseEnum = keyof typeof PlanPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type PlanPagingDirectionTypeRequestEnum = Exclude<PlanPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки
 */
export enum PlanPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
}
/**
 * Справочник типов значений сортировки
 */
export type PlanPagingOrderByTypeResponseEnum = keyof typeof PlanPagingOrderByType
/**
 * Справочник типов значений сортировки
 */
export type PlanPagingOrderByTypeRequestEnum = Exclude<PlanPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос получения количества технологических планов
 */
export type GetPlanCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: PlanFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества технологических планов
 */
export type GetPlanCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего технологических планов
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetPlanCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества технологических планов
 */
export type GetPlanCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly planFilterValidation: PlanFilterValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества технологических планов
 */
export type GetPlanCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly planFilterValidation: PlanFilterValidationErrorResponseDto
}>
/**
 * Запрос получения технологических планов
 */
export type GetPlanListRequestDto = {
  /**
   * Фильтр
   */
  filter: PlanFilterRequestDto
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: PlanPagingRequestDto
}>
/**
 * Ответ на запрос получения технологических планов
 */
export type GetPlanListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Технологический план
   */
  readonly data: PlanResponseDto
  /**
   * Ошибка
   */
  readonly error: GetPlanListResponseErrorDto
}>
/**
 * Ошибка запроса получения технологических планов
 */
export type GetPlanListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly planFilterValidation: PlanFilterValidationErrorRequestDto
  /**
   * Ошибка пагинации по страницам
   */
  readonly planPagingValidation: PlanPagingValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения технологических планов
 */
export type GetPlanListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly planFilterValidation: PlanFilterValidationErrorResponseDto
  /**
   * Ошибка пагинации по страницам
   */
  readonly planPagingValidation: PlanPagingValidationErrorResponseDto
}>
/**
 * Запрос получения технологического плана
 */
export type GetPlanRequestDto = {
  /**
   * Идентификатор
   */
  id: number
}
/**
 * Ответ на запрос получения технологического плана
 */
export type GetPlanResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Технологический план
   */
  readonly data: PlanResponseDto
}>
/**
 * Технологический план(ТП)
 */
export type PlanRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Название
   */
  title: string
  /**
   * Описание
   */
  description?: string | null
  /**
   * Идентификаторы родительских технологических планов(ТП)
   */
  parentIds?: number[]
  /**
   * Идентификаторы регионов, в которых доступен технологический план(ТП)
   */
  rfIds?: number[]
  /**
   * Краткое описание
   */
  summary?: string | null
  /**
   * Тип иконки
   */
  iconType?: PlanIconTypeRequestEnum | "ICON_TYPE_UNKNOWN"
  /**
   * Описание опций
   */
  optionDescriptions?: PlanOptionDescriptionRequestDto[]
  /**
   * Привилегии.
   * Массив услуг доступных по технологическому плану
   */
  privilegeTypes?: privilegeV1.PrivilegeTypeRequestEnum[]
}
/**
 * Технологический план(ТП)
 */
export type PlanResponseDto = {
  /**
   * Идентификатор
   */
  readonly id: number
  /**
   * Название
   */
  title: string
  /**
   * Описание
   */
  description: string | null
  /**
   * Дата создания записи.
   * Заполняется сервером
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта
   */
  readonly changedAt: string
  /**
   * Идентификаторы родительских технологических планов(ТП)
   */
  parentIds: number[]
  /**
   * Идентификаторы регионов, в которых доступен технологический план(ТП)
   */
  rfIds: number[]
  /**
   * Краткое описание
   */
  summary: string | null
  /**
   * Тип иконки
   */
  iconType: PlanIconTypeResponseEnum
  /**
   * Описание опций
   */
  optionDescriptions: PlanOptionDescriptionResponseDto[]
  /**
   * Привилегии.
   * Массив услуг доступных по технологическому плану
   */
  privilegeTypes: privilegeV1.PrivilegeTypeResponseEnum[]
}
/**
 * Описание опции
 */
export type PlanOptionDescriptionRequestDto = {
  /**
   * Тип иконки
   */
  iconType?: PlanIconTypeRequestEnum | "ICON_TYPE_UNKNOWN"
  /**
   * Название
   */
  title: string
  /**
   * Краткое описание
   */
  summary?: string | null
}
/**
 * Описание опции
 */
export type PlanOptionDescriptionResponseDto = {
  /**
   * Тип иконки
   */
  iconType: PlanIconTypeResponseEnum
  /**
   * Название
   */
  title: string
  /**
   * Краткое описание
   */
  summary: string | null
}
/**
 * Фильтр по технологическим планам
 */
export type PlanFilterRequestDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Поиск производится по полям:
   * # - Название;
   * # - Описание;
   * # - Краткое описание
   */
  text?: string | null
  /**
   * По идентификаторам регионов
   */
  rfIds?: number[]
}
/**
 * Фильтр по технологическим планам
 */
export type PlanFilterResponseDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Поиск производится по полям:
   * # - Название;
   * # - Описание;
   * # - Краткое описание
   */
  text: string | null
  /**
   * По идентификаторам регионов
   */
  rfIds: number[]
}
/**
 * Ошибки валидации фильтра по технологическим планам.
 * Эти проверки выполняются до обращения в базу данных
 */
export type PlanFilterValidationErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Текст передан некорректно
   */
  readonly text: PlanFilterValidationErrorTextInvalidRequestDto
}>
/**
 * Ошибки валидации фильтра по технологическим планам.
 * Эти проверки выполняются до обращения в базу данных
 */
export type PlanFilterValidationErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Текст передан некорректно
   */
  readonly text: PlanFilterValidationErrorTextInvalidResponseDto
}>
/**
 * Причины:
 * - Длина текста < 3 символов и >= 64
 */
export type PlanFilterValidationErrorTextInvalidRequestDto = {
}
/**
 * Причины:
 * - Длина текста < 3 символов и >= 64
 */
export type PlanFilterValidationErrorTextInvalidResponseDto = {
}
/**
 * Пагинация по технологическим планам
 */
export type PlanPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType?: PlanPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: PlanPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация по технологическим планам
 */
export type PlanPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType: PlanPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: PlanPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Ошибка валидации постраничной пагинации по технологическим планам.
 * Эти проверки выполняются до обращения в базу данных
 */
export type PlanPagingValidationErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: PlanPagingValidationErrorLimitInvalidRequestDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: PlanPagingValidationErrorOffsetInvalidRequestDto
}>
/**
 * Ошибка валидации постраничной пагинации по технологическим планам.
 * Эти проверки выполняются до обращения в базу данных
 */
export type PlanPagingValidationErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: PlanPagingValidationErrorLimitInvalidResponseDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: PlanPagingValidationErrorOffsetInvalidResponseDto
}>
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type PlanPagingValidationErrorLimitInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type PlanPagingValidationErrorLimitInvalidResponseDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type PlanPagingValidationErrorOffsetInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type PlanPagingValidationErrorOffsetInvalidResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос получения количества технологических планов
   */
  "GetPlanCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества технологических планов",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "PlanFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества технологических планов
   */
  "GetPlanCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества технологических планов",
    "fields": {
      /**
       * Всего технологических планов
       */
      "data": {
        "type": "int32",
        "text": "Всего технологических планов",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetPlanCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества технологических планов
   */
  "GetPlanCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества технологических планов",
    "fields": {
      /**
       * Ошибка фильтрации
       */
      "planFilterValidation": {
        "type": "PlanFilter.ValidationError",
        "text": "Ошибка фильтрации",
      },
    },
  },
  /**
   * Запрос получения технологических планов
   */
  "GetPlanListRequest": {
    "kind": "class",
    "text": "Запрос получения технологических планов",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "PlanFilter",
        "text": "Фильтр",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "PlanPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения технологических планов
   */
  "GetPlanListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения технологических планов",
    "fields": {
      /**
       * Технологический план
       */
      "data": {
        "type": "Plan",
        "text": "Технологический план",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetPlanListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения технологических планов
   */
  "GetPlanListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения технологических планов",
    "fields": {
      /**
       * Ошибка фильтрации
       */
      "planFilterValidation": {
        "type": "PlanFilter.ValidationError",
        "text": "Ошибка фильтрации",
      },
      /**
       * Ошибка пагинации по страницам
       */
      "planPagingValidation": {
        "type": "PlanPaging.ValidationError",
        "text": "Ошибка пагинации по страницам",
      },
    },
  },
  /**
   * Запрос получения технологического плана
   */
  "GetPlanRequest": {
    "kind": "class",
    "text": "Запрос получения технологического плана",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения технологического плана
   */
  "GetPlanResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения технологического плана",
    "fields": {
      /**
       * Технологический план
       */
      "data": {
        "type": "Plan",
        "text": "Технологический план",
      },
    },
  },
  /**
   * Технологический план(ТП)
   */
  "Plan": {
    "kind": "class",
    "text": "Технологический план(ТП)",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Название
       */
      "title": {
        "type": "string",
        "text": "Название",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Описание
       */
      "description": {
        "type": "google.protobuf.StringValue",
        "text": "Описание",
      },
      /**
       * Дата создания записи.
       * Заполняется сервером
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания записи.\nЗаполняется сервером",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта",
      },
      /**
       * Идентификаторы родительских технологических планов(ТП)
       */
      "parentIds": {
        "type": "int32",
        "text": "Идентификаторы родительских технологических планов(ТП)",
      },
      /**
       * Идентификаторы регионов, в которых доступен технологический план(ТП)
       */
      "rfIds": {
        "type": "int32",
        "text": "Идентификаторы регионов, в которых доступен технологический план(ТП)",
      },
      /**
       * Краткое описание
       */
      "summary": {
        "type": "google.protobuf.StringValue",
        "text": "Краткое описание",
      },
      /**
       * Тип иконки
       */
      "iconType": {
        "type": "Plan.IconType",
        "text": "Тип иконки",
      },
      /**
       * Описание опций
       */
      "optionDescriptions": {
        "type": "Plan.OptionDescription",
        "text": "Описание опций",
      },
      /**
       * Привилегии.
       * Массив услуг доступных по технологическому плану
       */
      "privilegeTypes": {
        "type": "Privilege.Type",
        "text": "Привилегии.\nМассив услуг доступных по технологическому плану",
      },
    },
  },
  /**
   * Описание опции
   */
  "Plan.OptionDescription": {
    "kind": "class",
    "text": "Описание опции",
    "fields": {
      /**
       * Тип иконки
       */
      "iconType": {
        "type": "Plan.IconType",
        "text": "Тип иконки",
      },
      /**
       * Название
       */
      "title": {
        "type": "string",
        "text": "Название",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Краткое описание
       */
      "summary": {
        "type": "google.protobuf.StringValue",
        "text": "Краткое описание",
      },
    },
  },
  /**
   * Фильтр по технологическим планам
   */
  "PlanFilter": {
    "kind": "class",
    "text": "Фильтр по технологическим планам",
    "fields": {
      /**
       * По тексту.
       * Если значение не передано то поиск по нему не производится.
       * # Поиск производится по полям:
       * # - Название;
       * # - Описание;
       * # - Краткое описание
       */
      "text": {
        "type": "google.protobuf.StringValue",
        "text": "По тексту.\nЕсли значение не передано то поиск по нему не производится.\n# Поиск производится по полям:\n# - Название;\n# - Описание;\n# - Краткое описание",
      },
      /**
       * По идентификаторам регионов
       */
      "rfIds": {
        "type": "int32",
        "text": "По идентификаторам регионов",
      },
    },
  },
  /**
   * Ошибки валидации фильтра по технологическим планам.
   * Эти проверки выполняются до обращения в базу данных
   */
  "PlanFilter.ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации фильтра по технологическим планам.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Текст передан некорректно
       */
      "text": {
        "type": "PlanFilter.ValidationError.TextInvalid",
        "text": "Текст передан некорректно",
      },
    },
  },
  /**
   * Причины:
   * - Длина текста < 3 символов и >= 64
   */
  "PlanFilter.ValidationError.TextInvalid": {
    "kind": "class",
    "text": "Причины:\n- Длина текста < 3 символов и >= 64",
  },
  /**
   * Пагинация по технологическим планам
   */
  "PlanPaging": {
    "kind": "class",
    "text": "Пагинация по технологическим планам",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: ID
       */
      "orderByType": {
        "type": "PlanPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "PlanPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Ошибка валидации постраничной пагинации по технологическим планам.
   * Эти проверки выполняются до обращения в базу данных
   */
  "PlanPaging.ValidationError": {
    "kind": "class",
    "text": "Ошибка валидации постраничной пагинации по технологическим планам.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Количество передано некорректно
       */
      "limit": {
        "type": "PlanPaging.ValidationError.LimitInvalid",
        "text": "Количество передано некорректно",
      },
      /**
       * Сдвиг передан некорректно
       */
      "offset": {
        "type": "PlanPaging.ValidationError.OffsetInvalid",
        "text": "Сдвиг передан некорректно",
      },
    },
  },
  /**
   * Причины:
   * - Значение количества < 0 или > 100
   */
  "PlanPaging.ValidationError.LimitInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение количества < 0 или > 100",
  },
  /**
   * Причины:
   * - Значение сдвига < 0
   */
  "PlanPaging.ValidationError.OffsetInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение сдвига < 0",
  },
  /**
   * Справочник типов иконок
   */
  "Plan.IconType": {
    "kind": "enum",
    "text": "Справочник типов иконок",
    "values": {
      /**
       * Значение не указано
       */
      "ICON_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Быстро
       */
      "FAST": {
        "i": 1,
        "text": "Быстро",
      },
      /**
       * Распознавание лиц
       */
      "FACE_REC": {
        "i": 2,
        "text": "Распознавание лиц",
      },
      /**
       * Безопасно
       */
      "SAFE": {
        "i": 3,
        "text": "Безопасно",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "PlanPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки
   */
  "PlanPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
    },
  },
}